var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md"},[_c('div',{},[_c('h2',{staticClass:"ftco-heading-2"},[_vm._v("404")]),_c('p',[_vm._v(_vm._s(_vm.content))])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }